<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <p [innerHtml]="MessageText"></p>

    <div class="boxShadow" style="margin-top: 15px;">
        <table mat-table matSort matSortActive="DateUpdated" matSortDirection="desc" matTableResponsive [dataSource]="dataSource" class="clearSidePaddings">
            <ng-container matColumnDef="StudentName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered" style="width: 15%"> Student Name </th>
                <td mat-cell *matCellDef="let item" class="centered"> {{item.StudentName}} </td>
            </ng-container>

            <ng-container matColumnDef="StudentID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered" style="width: 15%"> Student ID </th>
                <td mat-cell *matCellDef="let item" class="centered"> {{item.StudentID}} </td>
            </ng-container>

            <ng-container matColumnDef="ProgramsApplied">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered"> Program(s) Applied </th>
                <td mat-cell *matCellDef="let item" class="centered" title="Recommended Program Name">
                    <div *ngFor="let pgm of item.ProgramsApplied">
                        <span [ngStyle]="{'text-decoration': pgm.Approved === false ? 'line-through' : 'none'}">{{pgm.ProgramName || 'N/A'}}</span>
                        <span *ngIf="pgm.Approved === true"> (Approved)</span>
                        <span *ngIf="pgm.Approved === false"> (Denied)</span>
                        <span *ngIf="pgm.Approved == null"> (Pending)</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="DateUpdated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered" style="width: 15%"> Date Updated </th>
                <td mat-cell *matCellDef="let item" class="centered"> {{item.DateUpdated | date:'short'}} </td>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef style="width: 10%" class="centered"></th>
                <td mat-cell *matCellDef="let item" class="centered">
                    <button mat-raised-button color="primary" (click)="ViewApplication($event, item)">View</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="primary" style="border:1px solid gray;color:#fff"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let even = even;" [class.evenRow]="even" style="border:1px solid gray;line-height:1.5rem"></tr>

            <tr class="mat-row" *matNoDataRow style="border:1px solid gray;line-height:1.5rem">
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    <em>No notification items were found.</em>
                </td>
            </tr>
        </table>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="OKHandler()">OK</button>
</div>